import { navigate } from "gatsby"

import { Heading, IconButton } from "@trueskin-web/components"
import { useAuth } from "@trueskin-web/context"
import { getCountries } from "@trueskin-web/locales"
import { simpleEditIcon } from "@trueskin-web/theme/icons/simpleEditIcon"
import { Routes, Trans } from "@trueskin-web/translations"

const countries = getCountries()

const Address = ({ address }) => (
  <div
    data-hj-suppress
    sx={{
      hyphens: "auto",
      wordBreak: "break-word",
    }}
  >
    <div data-testid="web-portal-summary-user-name">
      {address.firstName
        ? `${address.firstName} ${address.lastName}`
        : address.name}
    </div>
    <div data-testid="web-portal-summary-user-street">{address.street}</div>
    {address.additionalAddress && <div>{address.additionalAddress}</div>}
    <div data-testid="web-portal-summary-user-city-country">
      {address.postalCode} {address.city},{" "}
      {countries.find((country) => country.code === address.country).label}
    </div>
  </div>
)

const Addresses = ({ className, repurchase }) => {
  const {
    user: {
      isShippingAddressSameAsBillingAddress,
      billingAddresses: [billingAddress],
      addresses: shippingAddresses,
    },
  } = useAuth()

  const shippingAddress = isShippingAddressSameAsBillingAddress
    ? billingAddress
    : shippingAddresses.find((address) => address.selected)

  const handleClick = (sectionName = "") => {
    const url = repurchase
      ? Routes.App.Account.Profile.url
      : Routes.App.Start.Shipping.url

    navigate(url + sectionName)
  }

  return (
    <div
      data-clarity-mask="True"
      className={className}
      data-component-name="PaymentAddresses"
    >
      <Heading
        as="h3"
        mt={6}
        mb={4}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          py: 3,
          borderBottom: "1px solid",
          borderColor: "brandNeutralsMediumGrey",
          fontSize: 2,
          textTransform: "uppercase",
          fontWeight: "bold",
          letterSpacing: 0.1,
        }}
      >
        <Trans i18nKey="Payment.Overview.Addresses.billingInfo" />
        <IconButton
          icon={simpleEditIcon}
          iconSize="sm"
          onClick={() => handleClick()}
          sx={{ color: "text" }}
        />
      </Heading>
      <Address address={billingAddress} />
      <Heading
        as="h3"
        mt={6}
        mb={4}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          py: 3,
          borderBottom: "1px solid",
          borderColor: "brandNeutralsMediumGrey",
          fontSize: 2,
          textTransform: "uppercase",
          fontWeight: "bold",
          letterSpacing: 0.1,
        }}
      >
        <Trans i18nKey="Payment.Overview.Addresses.shippingInfo" />
        <IconButton
          icon={simpleEditIcon}
          iconSize="sm"
          onClick={() => handleClick("#shipping-address")}
          sx={{ color: "text" }}
        />
      </Heading>

      {isShippingAddressSameAsBillingAddress ? (
        <Trans i18nKey="Payment.Overview.Addresses.sameAddress" />
      ) : (
        <Address address={shippingAddress} />
      )}
    </div>
  )
}

export default Addresses
